import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { Typography, Box } from '@mui/material';
import { Controller } from 'react-hook-form';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment-timezone';

moment.tz.setDefault('Europe/London');

const classes = {
  '& .MuiOutlinedInput-root': {
    paddingRight: 0,
  },
  '& .MuiOutlinedInput-input': {
    fontWeight: 500,
    fontSize: 14,
    padding: '13px',
    color: '#000000E3',
  },
  '& .MuiIconButton-root': {
    borderRadius: '4px',
    padding: '6px',
    right: '12px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: '1px',
  },
};

export default function HealtheraDatePicker({ name, control, rules = undefined, label, ...props }) {
  return (
    <Box className="flex flex-col">
      {label && (
        <Typography component="label" className="font-500 text-typography-primary mb-8">
          {label} <span className="text-typography-danger">*</span>
        </Typography>
      )}
      <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en-gb">
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field: { ref, ...rest }, fieldState: { error } }) => (
            <>
              <DatePicker sx={classes} timezone="UTC" {...rest} format="DD-MM-YYYY" {...props} />
              {error && (
                <Typography className="text-12 text-typography-danger ml-4 mt-4">
                  {error.message}
                </Typography>
              )}
            </>
          )}
        />
      </LocalizationProvider>
    </Box>
  );
}
